import { ReactNode } from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  min-height: 320px;
  padding: 24px 16px;
  text-align: center;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #e2e8f0;
  border-radius: 50%;

  svg {
    width: 32px;
    height: 32px;
    color: #334155;
  }
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: 360px;
`

const Title = styled.h3`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #334155;
`

const Description = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #475569;
`

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description?: ReactNode
}

export const EmptyState = ({ icon, title, description }: EmptyStateProps) => (
  <Container>
    <IconWrapper>{icon}</IconWrapper>
    <Body>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Body>
  </Container>
)
